const redirectUrl = window.redirectPath;
let referrer = "";

if (document.referrer) {
  const url = document.referrer;
  referrer = new URL(url).hostname;
}

// Fallback redirect in case Plausible is blocked or doesn't load
setTimeout(() => {
  window.location.href = redirectUrl;
}, 1000);

// Plausible conversion event tracking is defined globally in <head/>
// eslint-disable-next-line no-undef
plausible("Powered-by Referral", {
  callback: () => {
    window.location.href = redirectUrl;
  },
  props: { referrer },
});
